import "./channel-item.css";
import { NavLink } from "../../../../app/router/routes/NavLink";

const ChannelItem = ({ Icon, title, to, is_exact, count }) => {
  return (
    <NavLink
      activeClassName="is-active"
      inactiveClassName="is-inactive"
      className="channel-item"
      to={to}
      exact={is_exact}
    >
      <Icon className="icon" />
      <p>{title}</p>
      {count > 0 && <span>{count}</span>}
    </NavLink>
  );
};

export default ChannelItem;
